import { call, delay, put, takeLatest } from 'redux-saga/effects';
import customerApis from './apis';
import { actions } from './slice';
import { ISagaFunc } from 'services/actionConfigs';
import { GetCustomerListParams, GetTicketByCustomerIdParams } from './constants';

const getCustomerList: ISagaFunc<GetCustomerListParams> = function* ({ payload }) {
  yield delay(200);
  try {
    const response = yield call(customerApis.customer.getList, payload);
    const newData = {
      ...response.data.data,
      point: response.data.data.point,
      amount: response.data.data.amount,
    };
    yield put(actions.async.getCustomerList.success(newData));
  } catch (error) {
    yield put(actions.async.getCustomerList.fail({}));
  }
};

const getCustomerDetail: ISagaFunc<string> = function* ({ payload }) {
  yield delay(200);
  try {
    const response = yield call(customerApis.customer.getDetail, payload);
    yield put(actions.async.getCustomerDetail.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getCustomerDetail.fail({}));
  }
};

const getCustomerSummary: ISagaFunc = function* () {
  yield delay(200);
  try {
    const response = yield call(customerApis.customer.getSummary);
    yield put(actions.async.getCustomerSummary.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getCustomerSummary.fail({}));
  }
};
const getTicketsByCustomerId: ISagaFunc<GetTicketByCustomerIdParams> = function* ({ payload }) {
  yield delay(200);
  try {
    const response = yield call(customerApis.customer.getTicketsByCustomerId, payload);
    yield put(actions.async.getTicketsByCustomerId.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getTicketsByCustomerId.fail({}));
  }
};

export default function* sagas() {
  yield takeLatest(actions.async.getCustomerList.fetch, getCustomerList);
  yield takeLatest(actions.async.getCustomerDetail.fetch, getCustomerDetail);
  yield takeLatest(actions.async.getCustomerSummary.fetch, getCustomerSummary);
  yield takeLatest(actions.async.getTicketsByCustomerId.fetch, getTicketsByCustomerId);
}
